import { render, staticRenderFns } from "./assistant-blocks.vue?vue&type=template&id=47b71fb4&"
import script from "./assistant-blocks.vue?vue&type=script&lang=js&"
export * from "./assistant-blocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b71fb4')) {
      api.createRecord('47b71fb4', component.options)
    } else {
      api.reload('47b71fb4', component.options)
    }
    module.hot.accept("./assistant-blocks.vue?vue&type=template&id=47b71fb4&", function () {
      api.rerender('47b71fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/assistant-blocks/assistant-blocks.vue"
export default component.exports